import { createContext } from 'react';
import type { DeckId } from '../../types/deck';

/** Shape of the deck-switcher state provided by `DeckProvider`. */
export type DeckContextValue = {
    /** The active deck id. */
    deckId: DeckId;
    /** Switch to a specific deck. */
    setDeckId: (id: DeckId) => void;
    /** Advance to the next deck in the switcher cycle. */
    cycleDeck: () => void;
};

/**
 * Global "which deck is on the table" state. The active deck re-skins every
 * card surface in the app — images, display titles/bodies and the main-page
 * header — while the identity system (and therefore the reading logic)
 * stays untouched. Persisted to localStorage by the provider so the choice
 * survives reloads.
 */
export const DeckContext = createContext<DeckContextValue | null>(null);
